import { render } from "./related_products.vue?vue&type=template&id=5b1781dd"
import script from "./related_products.vue?vue&type=script&lang=js"
export * from "./related_products.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__